import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesRoutingModule } from './pages-routing.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { HomeComponent } from './home/home.component';
import { TopBarComponent } from './home/top-bar/top-bar.component';
import { HeaderComponent } from './home/header/header.component';
import { BannerComponent } from './home/banner/banner.component';
import { BrandComponent } from './home/brand/brand.component';
import { CourseComponent } from './home/course/course.component';
import { WhyChooseComponent } from './home/why-choose/why-choose.component';
import { EventsComponent } from './home/events/events.component';
import { FooterComponent } from './home/footer/footer.component';
import { AboutComponent } from './home/about/about.component';
import { BackTopComponent } from './home/back-top/back-top.component';
import { SearchComponent } from './home/search/search.component';
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CursoPageComponent } from './cursos/curso-page/curso-page.component';
import { CursoLayoutComponent } from './cursos/curso-layout/curso-layout.component';
import { SobrePageComponent } from './sobre/sobre-page/sobre-page.component';
import { SobreLayoutComponent } from './sobre/sobre-layout/sobre-layout.component';
import { SedePageComponent } from './sede/sede-page/sede-page.component';
import { SedeLayoutComponent } from './sede/sede-layout/sede-layout.component';
import { PoloPageComponent } from './polo/polo-page/polo-page.component';
import { PoloLayoutComponent } from './polo/polo-layout/polo-layout.component';
import { InfraestruturaPageComponent } from './infraestrutura/infraestrutura-page/infraestrutura-page.component';
import { InfraestruturaLayoutComponent } from './infraestrutura/infraestrutura-layout/infraestrutura-layout.component';
import { CorpoDocentePageComponent } from './corpo-docente/corpo-docente-page/corpo-docente-page.component';
import { CorpoDocenteLayoutComponent } from './corpo-docente/corpo-docente-layout/corpo-docente-layout.component';
import { FacintGoianiaPageComponent } from './facint-goiania/facint-goiania-page/facint-goiania-page.component';
import { FacintGoianiaLayoutComponent } from './facint-goiania/facint-goiania-layout/facint-goiania-layout.component';
import { FacintecPageComponent } from './facintec/facintec-page/facintec-page.component';
import { FacintecLayoutComponent } from './facintec/facintec-layout/facintec-layout.component';
import { EjaLayoutComponent } from './eja/eja-layout/eja-layout.component';
import { EjaPageComponent } from './eja/eja-page/eja-page.component';
import { AtenaIdiomasPageComponent } from './atena-idiomas/atena-idiomas-page/atena-idiomas-page.component';
import { AtenaIdiomasLayoutComponent } from './atena-idiomas/atena-idiomas-layout/atena-idiomas-layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { CursoGraduacaoListComponent } from './cursos/curso-graduacao-list/curso-graduacao-list.component';
import { CursoPosGraduacaoListComponent } from './cursos/curso-pos-graduacao-list/curso-pos-graduacao-list.component';

@NgModule({
  declarations: [
    HomeComponent,
    TopBarComponent,
    HeaderComponent,
    BannerComponent,
    BrandComponent,
    CourseComponent,
    AboutComponent,
    WhyChooseComponent,
    EventsComponent,
    FooterComponent,
    BackTopComponent,
    SearchComponent,
    CursoPageComponent,
    CursoLayoutComponent,
    SobrePageComponent,
    SobreLayoutComponent,
    SedePageComponent,
    SedeLayoutComponent,
    PoloPageComponent,
    PoloLayoutComponent,
    InfraestruturaPageComponent,
    InfraestruturaLayoutComponent,
    CorpoDocentePageComponent,
    CorpoDocenteLayoutComponent,
    FacintGoianiaPageComponent,
    FacintGoianiaLayoutComponent,
    FacintecPageComponent,
    FacintecLayoutComponent,
    EjaPageComponent,
    EjaLayoutComponent,
    AtenaIdiomasPageComponent,
    AtenaIdiomasLayoutComponent,
    CursoGraduacaoListComponent,
    CursoPosGraduacaoListComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    ScrollToModule.forRoot(),
    CarouselModule,
    NgbAccordionModule,
    NgxYoutubePlayerModule,
    TooltipModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    FormsModule
  ]
})
export class PagesModule { }
